import { type MarketplaceContract } from '@chewy/typescript-config/marketplace-types'
import { mainnet, polygon, optimism, arbitrum, base, shibarium } from 'viem/chains'

// Define marketplace contract addresses for each supported chain.
// Replace these placeholder addresses with actual deployed MarketplaceV3 contract addresses.
// Important: Ensure all contract addresses are actual deployed MarketplaceV3 addresses for the respective chains.
// Placeholder addresses must be updated for full functionality.
export const MARKETPLACE_CONTRACTS: MarketplaceContract[] = [
  {
    address: '0xeb7582edDB1C95F44022E822FA81A8fCa8551eF3', // FIXME: Replace with actual deployed contract address
    chain: {
      id: shibarium.id,
      name: shibarium.name
    }
  },
]

// Function to get marketplace contract by chain ID
export function getMarketplaceContract(chainId: number): MarketplaceContract | undefined {
  return MARKETPLACE_CONTRACTS.find(contract => contract.chain.id === chainId)
}